import { render } from "./Encuentro2024.vue?vue&type=template&id=66cef887&scoped=true"
import script from "./Encuentro2024.vue?vue&type=script&lang=js"
export * from "./Encuentro2024.vue?vue&type=script&lang=js"

import "./Encuentro2024.vue?vue&type=style&index=0&id=66cef887&lang=css"
import "./Encuentro2024.vue?vue&type=style&index=1&id=66cef887&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-66cef887"

export default script